module.exports = __webpack_public_path__ + "img/4.11857627.png";